<script>
import { etatPanierRecupereProps } from "./mixin";
import Button from "@/components/atoms/button";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Divider from "@/components/atoms/divider";
import EtatPanierItemList from "@/components/organisms/etat-panier/etat-panier-item-list/default";
import { useEtatPanier } from "../mixin";

export default {
  name: "EtatPanierRecupere",
  components: {
    Button,
    Icon,
    Badge,
    Divider,
    EtatPanierItemList
  },
  props: {
    ...etatPanierRecupereProps()
  },
  emits: ["ignore"],
  setup(props) {
    const { status, dateLastUpdate } = useEtatPanier(props.etatPanier);
    return { status, dateLastUpdate };
  }
};
</script>

<template>
  <div>
    <div class="u-text-center">
      <Badge
        variant="secondary"
        class="u-mb-sm u-p-xs"
        circle
        size="xlg"
      >
        <Icon
          name="cart"
          variant="white"
          size="md"
        />
      </Badge>
      <p>
        Les produits présents dans votre panier le {{ dateLastUpdate }} ont été rechargés.
      </p>
      <div class="u-mt-md">
        <template v-if="indisponibles && indisponibles.length > 0">
          <div>
            <Divider dotted />
            <h1 class="u-font-secondary u-color-primary u-font-24 u-font-700 u-mt-md u-mb-md">
              <template v-if="indisponibles.length === 1">
                Ce produit a été supprimé car il n'est plus disponible
              </template>
              <template v-else>
                Ces produits ont été supprimés car ils ne sont plus disponibles
              </template>
            </h1>
          </div>
          <div class="u-mb-xlg">
            <EtatPanierItemList
              :produits="indisponibles"
              show-similaires
            />
          </div>
          <div>
            <div class="u-pl-xxlg u-pl-none@md u-pr-xxlg u-pr-none@md">
              <Button
                outline
                variant="primary"
                size="md"
                radius="full"
                class="u-mt-xs"
                @click="$emit('ignore')"
              >
                Ignorer
              </Button>
            </div>
          </div>
        </template>
        <Button
          v-else
          variant="primary"
          link
          @click="$emit('ignore')"
        >
          Ok j'ai compris !
        </Button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
